import { render, staticRenderFns } from "./HighlightedCard.vue?vue&type=template&id=25d0c2dd&scoped=true&"
import script from "./HighlightedCard.vue?vue&type=script&lang=js&"
export * from "./HighlightedCard.vue?vue&type=script&lang=js&"
import style0 from "./HighlightedCard.vue?vue&type=style&index=0&id=25d0c2dd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d0c2dd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VCard,VCardSubtitle,VCardTitle,VProgressLinear})
